import { call, put, select, takeLatest } from 'redux-saga/effects';
import normalize from 'jsonapi-normalizer';

import { alternativeAssets } from '../../../api';
import { resourceReducer } from '../../utils/resourceReducer';
import { transformActiveFilters, waitFor } from '../../../services';
import { activeFiltersSelector } from '../../ui/portfolio/selectors';

export const [actions, reducer, resourceSagas] = resourceReducer(
  'alternative-assets',
  {
    mergeOnIndex: false,
  }
);

function* readAlternativeAssets() {
  yield takeLatest(actions.indexRequestBegin, function* () {
    yield call(waitFor, (state) => state.ui.portfolio.initialized);
    const activeFilters = yield select(activeFiltersSelector);
    // Remove period and date filters since they are not in use on the alternative assets endpoint
    const args = { ...transformActiveFilters(activeFilters) };
    delete args.period;
    delete args.startDate;
    delete args.endDate;

    try {
      const result = yield call(alternativeAssets.get, args);
      const { meta } = result;
      const normalized = normalize(result);
      yield put(actions.indexRequestSuccess({ ...normalized, meta }));
    } catch (error) {
      yield put(actions.indexRequestFailure({ error }));
      yield put({ type: 'ERRORS/HANDLE_API_ERROR', payload: error });
    }
  });
}

export const sagas = [readAlternativeAssets, ...resourceSagas];
